import React, { useState } from "react";
import PageTitle from "../../components/shared/PageTitle";
import ComingSoon from "../../components/shared/ComingSoon";

export default function RaceResult() {
    const [currentIndex, setCurrentIndex] = useState(3);
    return (
        <div className="text-white md:px-0 px-4">
            {/* <ComingSoon /> */}
            <div className="relative">
                <PageTitle title={"Race Result"} />
            </div>
            <div className="top-80 relative bg-black pb-96">
                <div className="bg-black min-h-screen container mx-auto w-full font-ronzino text-white ">
                    <div className="flex items-center justify-center flex-row gap-x-10">
                        {/* <button
                            onClick={() => setCurrentIndex(0)}
                            className={`py-2 border-white px-8 text-lg ${
                                currentIndex === 0 ? "font-bold border-b" : ""
                            }`}
                        >
                            2023
                        </button>
                        <button
                            onClick={() => setCurrentIndex(1)}
                            className={`py-2 border-white px-8 text-lg ${
                                currentIndex === 1 ? "font-bold border-b" : ""
                            }`}
                        >
                            2024
                        </button>
                        <button
                            onClick={() => setCurrentIndex(2)}
                            className={`py-2 border-white px-8 text-lg ${
                                currentIndex === 2 ? "font-bold border-b" : ""
                            }`}
                        >
                            2025
                        </button> */}
                        <button
                            onClick={() => setCurrentIndex(3)}
                            className={`py-2 border-white px-8 text-lg ${currentIndex === 3 ? "font-bold border-b" : ""
                                }`}
                        >
                            2026
                        </button>
                    </div>
                    <div className="mt-20 2xl:px-0 md:px-14 px-0">
                        {currentIndex === 0 ? (
                            <iframe
                                title="Lokasi"
                                src="https://results.scorenow.co.id/results.aspx?CId=19723&RId=156"
                                allowfullscreen="true"
                                loading="lazy"
                                referrerpolicy="no-referrer-when-downgrade"
                                className="w-full h-[90rem] rounded-lg"
                            ></iframe>
                        ) : currentIndex === 1 ? (
                            <iframe
                                title="Lokasi"
                                src="https://result.race.id/results.aspx?CId=20127&RId=6005"
                                allowfullscreen="true"
                                loading="lazy"
                                referrerpolicy="no-referrer-when-downgrade"
                                className="w-full h-[90rem] rounded-lg"
                                ></iframe>
                            ) : currentIndex === 2 ? (
                                <iframe
                                    title="Lokasi"
                                    src="https://result.race.id/Results.aspx?CId=20127&RId=6049&EId=1"
                                    allowfullscreen="true"
                                    loading="lazy"
                                    referrerpolicy="no-referrer-when-downgrade"
                                    className="w-full h-[90rem] rounded-lg"
                            ></iframe>

                        ) : (
                            <iframe
                                title="Lokasi"
                                src="https://www.racetecresults.com/results.aspx?CId=20127&RId=3116"
                                allowfullscreen="true"
                                loading="lazy"
                                referrerpolicy="no-referrer-when-downgrade"
                                className="w-full h-[90rem] rounded-lg"
                            ></iframe>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
}
